import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Flex, Spinner } from '@radix-ui/themes';

interface AdminProtectedRouteProps {
    children: React.ReactNode;
}

const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

    useEffect(() => {
        const checkSession = async () => {
            try {
                const response = await fetch('/v1/auth/admin/check-session', {
                    method: 'GET',
                });

                if (response.ok) {
                    const data = await response.json();
                    setIsAuthenticated(data.authenticated);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (err) {
                console.error('Session check failed', err);
                setIsAuthenticated(false);
            }
        };

        checkSession();
    }, []);

    if (isAuthenticated === null) {
        return (
            <Flex align="center" justify="center" style={{ height: '100vh' }}>
                <Spinner size="3" />
            </Flex>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return <>{children}</>;
};

export default AdminProtectedRoute;
